/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {registerAccount} from '../api'

export const useMutationRegisterAccount = createReactQueryMutationHook('registerAccount', registerAccount)
